<template>
  <div>
    <div class="boires-page-loader-div" v-if="isLoading">
      <div class="boires-page-loader"></div>
    </div>
    <MainLayout v-if="!isLoading">
      <div :class="[isMobileLayout ? 'container' : 'provider-container']">
        <PreviousPageBtn :label-code="'providers'" />
        <div>
          <mq-layout :mq="['xs', 'sm', 'md']">
            <el-row>
              <el-col :span="24">
                <el-image v-if="thumbnail != ''" class="provider-image__dimension" :src="thumbnail" :fit="'cover'" />
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="pl-15">
                <div class="provider-infos__position provider-title__dimension provider-infos__position--mobile">
                  <h1 class="text-left text-uppercase">
                    {{ provider && provider.name }}
                  </h1>
                </div>
                <div class="flex pt-5">
                  <el-image v-if="logo != ''" class="provider-logo__dimension" :src="logo" :fit="'contain'" />
                  <div class="subtitle2 subtitle2__color text-left pl-10">
                    {{ origin }}
                  </div>
                </div>
              </el-col>
            </el-row>
          </mq-layout>
          <mq-layout mq="lg+">
            <el-row>
              <el-col :span="12">
                <el-image v-if="thumbnail != ''" class="provider-image__dimension" :src="thumbnail" :fit="'cover'" />
              </el-col>
              <el-col :span="12" class="rectangle">
                <div class="provider-infos__position provider-title__dimension">
                  <h1 class="text-left text-uppercase">
                    {{ provider && provider.name }}
                  </h1>
                  <div class="flex pt-5">
                    <div class="subtitle2 subtitle2__color text-left">
                      <div class="region-text">{{ region }}</div>
                      {{ origin }}
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </mq-layout>
        </div>
        <div class="mt-70">
          <h4 class="text-left text-uppercase mb-20 ml-15"></h4>
          <ProductCarousel v-if="products && products.results && products.results.length > 0"
            :products="products && products.results" :backBtnName="backBtnName" arrow="always" id="product-carousel"/>
        </div>
        <div :class="[
          isMobileLayout ? 'provider-content--mobile' : '',
          'paragraph1 provider-content',
        ]">
          <div class="paragraph-content mb-30" v-html="provider && provider.content" />
          <div v-if="provider && provider.images" class="mt-20 img-gallery">
            <el-col v-for="(image, i) in imageSrcList" :key="i" :span="8" class="mb-3">
              <div class="thumbnail-image" @click="onClick(i)" v-bind:style="{ backgroundImage: 'url(' + image + ')' }">
              </div>
            </el-col>
          </div>
          <vue-gallery-slideshow :images="imageSrcList" :index="index" @close="index = null"></vue-gallery-slideshow>
        </div>
        <div class="mt-100 d-none">
          <h3 class="text-left text-uppercase mb-10 ml-5">
            {{ relatedArticlesLabel }}
          </h3>
          <el-col v-for="relatedArticle in temporaryRelatedArticles" :key="relatedArticle.id"
            :span="isMobileLayout ? 24 : 8" class="mb-60">
            <el-image class="related-articles__image" :src="relatedArticle.image.thumbnailLink" :fit="'cover'" />
            <h4 class="paragraph1 mt-5">
              {{ relatedArticle.content }}
            </h4>
          </el-col>
        </div>
        <div v-if="blogs && blogs.total > 0" :class="[isMobileLayout ? 'mt-50' : 'mt-140', 'text-left']">
          <el-row>
            <el-col class="producer-blog" :span="isMobileLayout ? 12 : 3">
              <h2 class="title text-uppercase mb-15 ml-5">
                {{ titleBlogs }}
              </h2>
            </el-col>
            <el-col
              :span="isMobileLayout ? 12 : 21"
              :class="[isMobileLayout ? 'text-right mt-4' : 'pl-10']"
            >
            </el-col>
          </el-row>
          <div
            class="blog-carousel home-blog-carousel"
            style="margin-left: -10px"
          >
            <BlogCarousel
              :carousel-type="2"
              :blogs="topVideos"
              arrow="always"
              :class="[isMobileLayout ? 'mt-12' : '']"
            />
          </div>
        </div>
      </div>
    </MainLayout>
    <el-dialog class="image-popup-modal img-popup modal-dialog-centered" :visible.sync="productImagePopup"
      :before-close="popupImageClose" :header="false">
      <el-row>
        <el-image class="" style="width: 100" :src="popImage.link" :fit="'contain'">
        </el-image>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { get, head, map,  reverse, take, isEmpty } from "@/utils/lodash";
import layoutUtils from "@/utils/layout-utils";
import { scrollUp } from "@/utils/common-utils";
import errorUtils from "@/utils/error-utils";

import MainLayout from "@/components/layout/main-layout.vue";
import PreviousPageBtn from "@/components/previous-page-btn.vue";
import ProductCarousel from "@/views/product/components/product-carousel.vue";
import BlogCarousel from "@/views/blog/components/blog-carousel.vue";

import imgDefault from "@/assets/images/provider/provider-desktop.svg";
import VueGallerySlideshow from "vue-gallery-slideshow";
import { forEach } from "@/utils/lodash";

export default {
  components: {
    MainLayout,
    PreviousPageBtn,
    ProductCarousel,
    VueGallerySlideshow,
    BlogCarousel
  },
  props: {
    slug: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isLoading: true,
      productImagePopup: false,
      imagePopuup: true,
      images: {
        providerDefault: {
          src: "",
        },
      },
      backBtnName: "producer",
      temporaryRelatedArticles: [
        {
          id: 1,
          content: "Visiter Toronto: Ossington Strip et Dundas Ouest",
          image: {
            id: 1,
            thumbnailLink: imgDefault,
          },
        },
        {
          id: 2,
          content: "Visiter Toronto: Ossington Strip et Dundas Ouest",
          image: {
            id: 2,
            thumbnailLink: imgDefault,
          },
        },
        {
          id: 3,
          content: "Visiter Toronto: Ossington Strip et Dundas Ouest",
          image: {
            id: 3,
            thumbnailLink: imgDefault,
          },
        },
      ],
      popImage: "",
      index: null,
    };
  },
  computed: {
    ...mapState("provider", ["provider"]),
    ...mapState("product", ["products"]),
    ...mapState("blog", ["blogs"]),
    origin() {
      let origin = "";
      if (this.provider) {
        const originHead = head(get(this.provider, "origins"));
        const country = get(originHead, "country.name");
        origin = originHead && `${country}`;
      }

      return origin;
    },
    region() {
      let region = "";
      if (this.provider) {
        const originHead = head(get(this.provider, "origins"));
        const reg = get(originHead, "region.name", "");
        region = originHead && `${reg == null ? "" : reg}`;
      }

      return region;
    },
    thumbnail() {
      const thumbnail = get(this.provider, "mainImage.link");

      if (thumbnail == null) {
        return this.images.providerDefault.src;
      }

      return thumbnail;
    },
    logo() {
      const logo = get(this.provider, "logo.thumbnailLink");

      if (logo == null) {
        return "";
      }

      return logo;
    },

    producerProductsLabel() {
      return this.$i18n.t("providers.providerView.label.producerProduct");
    },
    relatedArticlesLabel() {
      return this.$i18n.t("providers.providerView.label.relatedArticles");
    },
    imageSrcList() {
      const images = get(this.provider, "images");
      return map(images, "link");
    },
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
    titleBlogs() {
      return this.$i18n.t("home.homeView.blogsCarousel.title1");
    },
    topVideos() {
      const blogs = get(this.blogs, "results");
      if (!isEmpty(blogs)) {
        const sorted = reverse(blogs);
        const val = take(
          sorted,
          this.isMobileLayout ? this.totalBlogs : blogs.length
        );
        return val;
      }

      return [];
    },
  },
  watch: {
    products(val) {
      if (val.results) {
        forEach(val.results, (e) => {
          if (e.productInventories) {
            let price = e.productInventories.find(
              (r) =>
                r.id == e.id &&
                (r.inventory.code == "IP" || r.inventory.code == "SAQ")
            );
            if (price) {
              e.erpProduct = price;
              e.inventory = e.erpProduct.inventory;
            }
          } else {
            e.erpProduct = e;
          }
        });
      }
    },
  },
  created() {
    this.resetState();
    this.getProvider(this.slug, "slug");    
    this.$root.$on("chanLang", () => {
      this.getProvider(this.slug, "slug");
    });
  },
  mounted() {
    scrollUp();
  },
  methods: {
    ...mapActions("provider", ["fetchProvider"]),
    ...mapActions("product", ["fetchProducerProduct"]),
    ...mapActions("blog", ["fetchBlogs"]),
    ...mapMutations("provider", ["resetState"]),
    popupImageClose() {
      this.productImagePopup = false;
    },
    getProducts(providerId) {
      let filters = {
        page: 1,
        size: 51,
        availability: ["IP", "SAQ", "Brouhh", "MERCH_MTL"],
        // show: "AVAILABLE_UPCOMING",
        providerId,
      };
      this.fetchProducerProduct({ filters })
        .then(() => {
          this.isLoading = false;
          // this.stopLoading();
        })
        .catch(() => {
          this.isLoading = false;
          // this.stopLoading();
        });
    },
    getBlog(providerId) {
      this.fetchBlogs({
        filters: {
            page: 1,
            size: 52,
            // types: ["DEFAULT"],
            providerId: [providerId],
          },
      });
    },
    popImgOpen(image) {
      this.productImagePopup = true;
      this.popImage = image;
    },
    getProvider(id, idType) {
      this.isLoading = true;
      this.fetchProvider({
        id,
        idType,
      })
        .then(() => {
          this.getProducts(this.provider.id);
          this.getBlog(this.provider.id);
        })
        .catch((error) => {
          this.isLoading = false;
          if (errorUtils.extractErrorHttpStatusCode(error) === 404) {
            this.$router.push({
              name: "notFound",
              query: {
                type: "providers",
              },
            });
          }
        });
    },
    onClick(i) {
      this.index = i;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/variables.scss";
$provider-image-size-sm: 383px;
$provider-image-size-md: 470px;
$provider-image-size-lg: 550px;
$logo-dimension: 80px;
$related-article-image-lg: 372px;
$related-article-image-md: 320px;
$related-article-image-sm: 400px;

.provider-container {

  // sm -
  @media screen and (max-width: $media-md) {
    margin: 0;
  }

  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    width: $container-max-width-md;
    margin-left: auto;
    margin-right: auto;
  }

  // lg +
  @media screen and (min-width: $media-lg) {
    width: $container-max-width-lg;
    margin-left: auto;
    margin-right: auto;
  }
}

.provider-image__dimension {

  // sm -
  @media screen and (max-width: $media-md) {
    height: $provider-image-size-sm;
  }

  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    height: $provider-image-size-md;
    width: $provider-image-size-md;
  }

  // lg +
  @media screen and (min-width: $media-lg) {
    height: $provider-image-size-lg;
    width: $provider-image-size-lg;
  }
}

.rectangle {
  background-color: rgba(237, 240, 237, 0.33);
  margin-left: -15px;
  padding-left: 40px;
}

.provider-title__dimension {

  // sm -
  @media screen and (max-width: $media-md) {}

  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    width: $provider-image-size-md;
    height: $provider-image-size-md;
  }

  // lg +
  @media screen and (min-width: $media-lg) {
    width: $provider-image-size-lg;
    height: $provider-image-size-lg;
  }
}

.provider-logo__dimension {
  height: $logo-dimension;
  width: $logo-dimension;
  border: solid #80808052 1px;
}

.provider-infos__position {
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  justify-content: center;

  & h1 {
    font-family: $font-family-bold-condensed;
    letter-spacing: 0.6px;
    color: #333333;

    // sm -
    @media screen and (max-width: $media-md) {
      line-height: 36px;
    }

    // md +
    @media screen and (min-width: $media-md) {
      line-height: 50px;
    }
  }

  & div {
    color: $color-on-background-area1;
  }
}

.subtitle2__color {
  color: $color-on-background-area1;
}

.provider-infos__position--mobile {
  justify-content: flex-start;
}

.provider-logo__position {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.provider-content {
  width: 80%;
  display: inline-flex;
  flex-direction: column;
  font-size: 20px;

  .paragraph-content {
    p {
      padding-bottom: 20px;
    }
  }
}

.provider-content--mobile {
  width: 100%;
}

.provider-content__image {
  width: 98%;
  height: 230px;
}

.provider-content__image--mobile {
  height: 121px;
}

.related-articles__image {

  // sm -
  @media screen and (max-width: $media-md) {
    height: $related-article-image-sm;
  }

  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    height: $related-article-image-md;
    width: $related-article-image-md;
  }

  // lg +
  @media screen and (min-width: $media-lg) {
    height: $related-article-image-lg;
    width: $related-article-image-lg;
  }
}

.d-none {
  display: none;
}

@media screen and (max-width: 1024px) {
  .img-gallery {
    .el-col-8 {
      padding: 1px;
    }
  }
}

.region-text {
  font-size: 18px !important;
}

.img-popup {
  max-width: 50%;
  margin: auto;

  @media screen and (max-width: 430px) {
    max-width: 100%;
  }

  .el-dialog {
    .el-img {
      max-width: 400px;
    }
  }

  img {
    pointer-events: unset !important;
  }
}
</style>
